var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.0.1.0@can-use-dom/index.js
 ** module id = 248
 ** module chunks = 0
 **/